/**
 * Entry point for the SPA (milestone v1.4).
 *
 * Mirrors the v1 entry point — StrictMode + ThemeProvider wrap App so CSS
 * variables resolve before the first render.
 */

import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import { ThemeProvider } from './context/ThemeContext';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider defaultMode="default">
      <App />
    </ThemeProvider>
  </StrictMode>,
);
